<div class="top-margin">
    <div class="container">
      <div class="d-flex align-items-center justify-content-center">
        <div class="col-md-6">
          <div class="clearfix">
            <h1 class="float-left display-3 mr-4">{{language.error}}!!</h1>
            <h4 class="pt-3"> {{language.somethingWentWrong}}</h4>
            <p class="text-muted"> {{language.pleaseConatctAdministrator}}..</p>
          </div>
          <!-- <div class="input-prepend input-group">
            <div class="input-group-prepend">
              <span class="input-group-text"><i class="fa fa-search"></i></span>
            </div>
            <input [(ngModel)]="searchText" class="form-control" size="16" type="text" placeholder="What are you looking for?">
            <span class="input-group-append">
              <button class="btn btn-info" type="button" (click)="goToUrl()">Search</button>
            </span>
          </div> -->
        </div>
      </div>
    </div>
  </div>
  